import { useContext } from 'react'
import { PreviewContext } from './previewContextCore'

export const usePreview = () => {
  const context = useContext(PreviewContext)
  if (!context) throw new Error('usePreview must be used within PreviewProvider')
  return context
}
